module.exports = __webpack_public_path__ + "img/otp-mail.c4b351bc.png";